import React, { useState, useEffect } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import BtxSwitch from '../Forms/BtxSwitch';
import { use } from 'react';

const NullableField = ({ component, className, name, placeholder, nullPlaceholder, ...rest }) => {

  const form = useForm(); // Allows programmatic value updates
  const { values } = useFormState(); // Access form state values

  // Get the initial value directly from form state
  const initialValue = values[name];

  // State to control whether the field is enabled or disabled
  const [isEnabled, setIsEnabled] = useState(initialValue !== null);

  // Initialize isEnabled state based on the form’s value
  useEffect(() => {
    setIsEnabled(initialValue !== null);
  }, [initialValue]);

  // warning on unsupported component types
  useEffect(() => {
    if (component && component !== 'input') {
      console.warn('NullableField: Unsupported component type of `' + component + '`. Only `input` is supported.');
    }
  });

  const handleSwitchChange = () => {
    // Toggle between "" and null
    const newEnabledState = !isEnabled;

    setIsEnabled(newEnabledState);
    form.change(name, newEnabledState ? '' : null); 
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>

      {/* Toggle Switch */}
      <div style={{ width: '80px' }}>
        <BtxSwitch
          value={isEnabled}
          onChange={handleSwitchChange}
        />
      </div>

      {/* Input Field */}
      <div style={{ width: '100%' }}>
        <Field name={name}>
          {({ input }) => {
            const value = isEnabled
              ? !input.value ? '' : input.value
              : null;

            // WORKAROUND: ensure that the value is persisted 
            // in the form state whether it is a null or an 
            // empty string
            form.change(name, value);

            return (
              <input
                {...input}
                className={className}
                placeholder={placeholder}
                disabled={!isEnabled}
                value={isEnabled ? value : nullPlaceholder} // Show "NULL" when disabled
                style={{
                  width: '100%',
                  background: !isEnabled ? '#f0f0f0' : 'white',
                  color: !isEnabled ? '#b0b0b0' : 'black',
                  padding: '0.5rem',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                }}
                {...rest}
              />
            );
          }}
        </Field>
      </div>

    </div>
  );
};

export default NullableField;
